import type { VFC } from 'react'
import type { AuthState, UserState } from '@sparky/framework'

const TsgNavTitle: VFC<{ auth: AuthState | undefined }> = ({ auth }) => {
  const { tsg_id = '', tsg_name = tsg_id, user } = auth || {} as AuthState
  const { email, firstname = '', lastname = '' } = user || {} as UserState
  const userName = `${firstname} ${lastname}`.trim() || email || ''
  return <>
    <div className='cm-text-left cm-text-nowrap cm-text-ellipsis cm-overflow-x-hidden' title={tsg_id}>{tsg_name}</div>
    <div className='cm-text-left cm-text-xs cm-text-nowrap cm-text-ellipsis cm-overflow-x-hidden -cm-mt-0.5 cm-mb-1'>{userName}</div>
  </>
}

const getSwitcherTitle = (auth: AuthState, nav3?: boolean) => {
  if (nav3) {
    return <TsgNavTitle auth={auth} />
  }
  else {
    return auth?.tsg_name || auth?.tsg_id || ''
  }
}

export default getSwitcherTitle
